{
  "caregivers": "intervenants",
  "caregiver": "intervenant",
  "caregivers_full": "assistants de vie",
  "caregiver_full": "assistant de vie",
  "caregiver_short": "ADV",
  "company_name": "Joya",
  "holiday_not_worked_label": "1er mai et 25 décembre"
}
